import React, { useState, useEffect } from 'react';
import { useAuth, apiFetch } from "../hooks/useAuth";
// import {
//     DataGrid, GridRowsProp, GridColDef,
//     GridToolbarContainer, GridToolbarExport, GridActionsCellItem
// } from '@mui/x-data-grid';

import { DataGridPro, GridToolbar, GridToolbarContainer, GridToolbarExport, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid-pro';


import EmailIcon from '@mui/icons-material/Email';
import CircleIcon from '@mui/icons-material/Circle';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import PrintIcon from '@mui/icons-material/Print';

import {
    IconButton, FormControlLabel, Stack, Alert,
    LinearProgress, Box, Modal, Typography, Tooltip, Button, ButtonGroup
} from "@mui/material/";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import { ModalDownload, ModalContact } from "./Modal";
import { deDE } from '@mui/x-data-grid-pro/locales'

const PRESET_SINCE_2023 = dayjs('2023-01-01');

const getDefaultDateRange = () => ({
    from: dayjs().subtract(12, 'month'),
    to: dayjs(),
});

const formatDateParam = (date) => date.format('YYYY-MM-DD');

const buildOrdersUrl = (accountID, fromDate, toDate, allowLargeRange = false) => {
    const accountIdString = Array.isArray(accountID) ? accountID.join(',') : accountID;
    const params = new URLSearchParams({
        kdnrs: accountIdString,
        from: formatDateParam(fromDate),
        to: formatDateParam(toDate),
    });
    if (allowLargeRange) {
        params.set('allowLargeRange', 'true');
    }
    return `/app/orders?${params.toString()}`;
};

const parseOrdersError = async (res) => {
    let errorMessage = 'Die Daten konnten nicht geladen werden.';
    if (res.status === 504 || res.status === 408) {
        errorMessage = 'Die Anfrage hat zu lange gedauert. Bitte versuchen Sie es erneut oder wenden Sie sich an den Support.';
    } else {
        try {
            const body = await res.json();
            if (body?.message) {
                errorMessage = body.message;
            }
        } catch (_) {
            // ignore non-JSON error bodies
        }
    }
    return errorMessage;
};

export const CmdService = ({ index }) => {
    const handleEditClick = () => {
        // some action
    };

    return (
        <FormControlLabel
            control={
                <IconButton
                    color="secondary"
                    aria-label="add an alarm"
                    onClick={handleEditClick}
                >
                    <EmailIcon />
                </IconButton>
            }
        />
    );
};

export function OrderList() {
    const { accountID, token } = useAuth();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [message, setMessage] = useState("");
    const [data, setData] = useState([]);
    const [startDate, setStartDate] = useState(getDefaultDateRange().from);
    const [endDate, setEndDate] = useState(getDefaultDateRange().to);
    const [appliedRange, setAppliedRange] = useState(getDefaultDateRange());
    const [allowLargeRange, setAllowLargeRange] = useState(false);

    const [currentRow, setCurrentRow] = useState(null);
    const [isModalDownloadOpen, setIsModalDownloadOpen] = useState(false);
    const [isModalContactOpen, setIsModalContactOpen] = useState(false);


    const apiRef = useGridApiRef();
    const handleStatusClick = (status) => {

        apiRef.current.setFilterModel({

            items: [{ field: 'Bestellstatus', operator: 'contains', value: status }],
        });

    };

    const currencyFormatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
    });

    // Custom print function that extracts all data and creates a printable view
    const handlePrint = () => {
        const visibleColumns = apiRef.current.getVisibleColumns();
        const allRows = apiRef.current.getSortedRowIds().map(id => apiRef.current.getRow(id));
        
        // Create a new window for printing
        const printWindow = window.open('', '_blank');
        
        // Build HTML with all rows
        const html = `
            <!DOCTYPE html>
            <html>
            <head>
                <title>Bestellstatus Drucken</title>
                <style>
                    body {
                        font-family: Arial, sans-serif;
                        margin: 20px;
                    }
                    h1 {
                        font-size: 18px;
                        margin-bottom: 20px;
                    }
                    table {
                        border-collapse: collapse;
                        width: 100%;
                        font-size: 10px;
                    }
                    th, td {
                        border: 1px solid #ddd;
                        padding: 6px;
                        text-align: left;
                    }
                    th {
                        background-color: #f5f5f5;
                        font-weight: bold;
                    }
                    tr:nth-child(even) {
                        background-color: #fafafa;
                    }
                    .status-circle {
                        display: inline-block;
                        width: 10px;
                        height: 10px;
                        border-radius: 50%;
                        margin-right: 5px;
                    }
                    .status-geliefert { background-color: #ffd700; }
                    .status-berechnet { background-color: #228b22; }
                    .status-bestellt { background-color: #ab2524; }
                    .status-storniert { background-color: grey; }
                    @media print {
                        body { margin: 10px; }
                    }
                </style>
            </head>
            <body>
                <h1>Bestellstatus - ${new Date().toLocaleDateString('de-DE')}</h1>
                <table>
                    <thead>
                        <tr>
                            ${visibleColumns.filter(col => col.field !== 'Reklamation').map(col => 
                                `<th>${col.headerName || col.field}</th>`
                            ).join('')}
                        </tr>
                    </thead>
                    <tbody>
                        ${allRows.map(row => `
                            <tr>
                                ${visibleColumns.filter(col => col.field !== 'Reklamation').map(col => {
                                    let value = row[col.field];
                                    
                                    // Format dates
                                    if (col.field === 'Bestelldatum' && value) {
                                        value = dayjs(value).format('DD.MM.YYYY');
                                    }
                                    // Format currency
                                    else if (col.field === 'Preis' && value) {
                                        value = currencyFormatter.format(value);
                                    }
                                    // Format status with colored circle
                                    else if (col.field === 'Bestellstatus' && value) {
                                        const statusClass = `status-${value.toLowerCase()}`;
                                        return `<td><span class="status-circle ${statusClass}"></span>${value}</td>`;
                                    }
                                    
                                    return `<td>${value || ''}</td>`;
                                }).join('')}
                            </tr>
                        `).join('')}
                    </tbody>
                </table>
            </body>
            </html>
        `;
        
        printWindow.document.write(html);
        printWindow.document.close();
        
        // Wait for content to load, then print
        printWindow.onload = () => {
            printWindow.print();
            printWindow.onafterprint = () => printWindow.close();
        };
    };

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbar printOptions={{ disableToolbarButton: true }} />
                <Button
                    startIcon={<PrintIcon />}
                    onClick={handlePrint}
                    size="small"
                >
                    Drucken
                </Button>
            </GridToolbarContainer>
        );
    }

    const applyPreset = (preset) => {
        let nextFrom;
        const nextTo = dayjs().startOf('day');
        let nextAllowLargeRange = false;

        if (preset === 'last12Months') {
            nextFrom = dayjs().subtract(12, 'month').startOf('day');
        } else if (preset === 'currentYear') {
            nextFrom = dayjs().startOf('year');
        } else if (preset === 'since2023') {
            nextFrom = PRESET_SINCE_2023;
            nextAllowLargeRange = true;
        } else {
            return;
        }

        setStartDate(nextFrom);
        setEndDate(nextTo);
        setAllowLargeRange(nextAllowLargeRange);
        setAppliedRange({ from: nextFrom, to: nextTo });
    };

    const handleApplyDateRange = () => {
        if (!startDate || !endDate) {
            setError('Bitte wählen Sie einen gültigen Datumsbereich.');
            return;
        }

        let nextFrom = startDate.startOf('day');
        let nextTo = endDate.startOf('day');

        if (nextTo.isAfter(dayjs())) {
            nextTo = dayjs().startOf('day');
        }
        if (nextFrom.isAfter(nextTo)) {
            setError('Das Startdatum darf nicht nach dem Enddatum liegen.');
            return;
        }

        const needsLargeRange = nextTo.diff(nextFrom, 'month') > 24;
        setStartDate(nextFrom);
        setEndDate(nextTo);
        setAllowLargeRange(needsLargeRange);
        setAppliedRange({ from: nextFrom, to: nextTo });
    };

    useEffect(() => {
        setData([]);

        if (!accountID || (Array.isArray(accountID) && accountID.length === 0)) {
            setError("Es wurde keine AccountID ausgewaehlt");
            return;
        }

        if (!token) {
            setError("Es gibt keinen definierten User Token");
        }

        setLoading(true);
        setError('');

        apiFetch(buildOrdersUrl(accountID, appliedRange.from, appliedRange.to, allowLargeRange))
            .then(async (res) => {
                if (!res.ok) {
                    throw new Error(await parseOrdersError(res));
                }
                return res.json();
            })
            .then((data) => {
                setLoading(false);
                setData(data);
                setMessage(
                    `Es werden Bestellungen zwischen ${appliedRange.from.format('DD.MM.YYYY')} und ${appliedRange.to.format('DD.MM.YYYY')} angezeigt.`
                );
            })
            .catch((err) => {
                setLoading(false);
                const errorMessage = err.message === 'Failed to fetch'
                    ? 'Die Verbindung zum Server ist fehlgeschlagen (Timeout). Bitte versuchen Sie es erneut.'
                    : err.message;
                setError(errorMessage);
            });

    }, [accountID, appliedRange, allowLargeRange, token]);

    return (
        <div style={{ height: "670px", width: '100%' }}>
            <Box
                mt={2}
                mb={2}
                sx={{ width: '100%', height: 4 }}>
                {loading && <LinearProgress />}
            </Box>

            {!loading && error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
            {!loading && message && <Alert severity="info" sx={{ mb: 2 }}>{message}</Alert>}

            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">
                <Stack
                    direction={{ xs: 'column', md: 'row' }}
                    spacing={2}
                    alignItems={{ md: 'center' }}
                    sx={{ mb: 3, gap: { xs: 2, md: 3 } }}
                >
                    <DatePicker
                        label="Von"
                        value={startDate}
                        maxDate={endDate || dayjs()}
                        onChange={(value) => setStartDate(value)}
                        slotProps={{ textField: { size: 'small' } }}
                        sx={{ minWidth: 160 }}
                    />
                    <DatePicker
                        label="Bis"
                        value={endDate}
                        minDate={startDate || undefined}
                        maxDate={dayjs()}
                        onChange={(value) => setEndDate(value)}
                        slotProps={{ textField: { size: 'small' } }}
                        sx={{ minWidth: 160 }}
                    />
                    <Button variant="contained" onClick={handleApplyDateRange} disabled={loading} sx={{ minWidth: 120 }}>
                        Anwenden
                    </Button>
                    <ButtonGroup size="small" variant="outlined" sx={{ ml: { md: 1 } }}>
                        <Button onClick={() => applyPreset('last12Months')}>Letzte 12 Monate</Button>
                        <Button onClick={() => applyPreset('currentYear')}>Aktuelles Jahr</Button>
                        <Button onClick={() => applyPreset('since2023')}>Seit 2023</Button>
                    </ButtonGroup>
                </Stack>
            </LocalizationProvider>

            <ModalDownload row={currentRow} isModalOpen={isModalDownloadOpen} handleCloseModal={() => setIsModalDownloadOpen(false)} />
            <ModalContact row={currentRow} isModalOpen={isModalContactOpen} handleCloseModal={() => setIsModalContactOpen(false)} />

            <Stack direction="row" alignItems="center" gap={2}
                sx={{ mb: 2, mt: 1, fontSize: "small" }}
            >
                <IconButton onClick={() => handleStatusClick("geliefert")}>
                    <CircleIcon
                        sx={{ color: "#ffd700" }}
                    />

                    <Typography color="text.secondary">geliefert</Typography>
                </IconButton>


                <IconButton onClick={() => handleStatusClick("berechnet")}>
                    <CircleIcon
                        sx={{ color: "#228b22" }}
                    />
                    <Typography color="text.secondary">berechnet</Typography>
                </IconButton>


                <IconButton onClick={() => handleStatusClick("bestellt")}>
                    <CircleIcon
                        sx={{ color: "#ab2524" }}
                    />

                    <Typography color="text.secondary">bestellt</Typography>
                </IconButton>

                <IconButton onClick={() => handleStatusClick("storniert")}>
                    <CircleIcon
                        sx={{ color: "grey" }}
                    />
                    <Typography color="text.secondary">storniert</Typography>
                </IconButton>

            </Stack>

            <div style={{ display: 'flex', height: '100%' }}>
                <div style={{ flexGrow: 1 }}>

                    <DataGridPro
                        apiRef={apiRef}



                        pageSize={10}
                        localeText={deDE.components.MuiDataGrid.defaultProps.localeText}


                        // getRowId={(row) => row.AuftragNr}
                        // componentsProps={{
                        //     toolbar: {
                        //         showQuickFilter: true,
                        //         quickFilterProps: { debounceMs: 500 },
                        //     },
                        // }}
                        slots={{ toolbar: CustomToolbar }}
                        slotProps={{
                            toolbar: {
                                showQuickFilter: true,
                                
                            },
                            filterPanel: {
                                onKeyDown: (event) => {
                                    console.log(event.key);
                                    if (event.key === 'Enter') {
                                        apiRef.current.hideFilterPanel()
                                    }
                                }
                            }
                        }}

                        initialState={{ pinnedColumns: { right: ['Reklamation'] } }}
                        rows={data}
                        columns={[
                            {
                                field: 'Bestellstatus',
                                headerName: "Status",
                                renderCell: (params) => {
                                    // console.log(params);
                                    let color = "";
                                    if (params.value === "geliefert") {
                                        color = "#ffd700";
                                    } else if (params.value === "berechnet") {
                                        color = "#228b22";
                                    } else if (params.value === "bestellt") {
                                        color = "#ab2524";
                                    } else if (params.value === "storniert") {
                                        color = "grey";
                                    }

                                    return (
                                        <CircleIcon
                                            sx={{ "color": color }}
                                        // color={params.value === "geliefert" ? "success" : "error"}
                                        />
                                    );
                                },
                                width: 80
                            },
                            {
                                field: 'AuftragNr',
                                headerName: "Auftragsnr.",
                                width: 80
                            },
                            {
                                field: 'KDNR',
                                headerName: "Kundennr.",
                                width: 80
                            },
                            {
                                field: 'Meldetext',
                                headerName: "Meldetext",
                                width: 80
                            },
                            {
                                field: 'ISBN',
                                width: 130
                            },
                            {
                                field: 'Titel',
                                width: 280,
                            },
                            {
                                field: "Anzahl",
                                width: 60,
                            },
                            {
                                field: 'Gesamtbetrag',
                                valueFormatter: (params) => {
                                    return currencyFormatter.format(params);
                                },
                                headerName: "Betrag",
                                type: "number",
                                width: 80,
                            },
                            {
                                field: 'Bestelldatum1',
                                headerName: "bestellt am",
                                type: "date",
                                valueFormatter: (params) => dayjs(params).format('DD.MM.YYYY'),

                            },
                            /*{
                                field: 'AuftragPosLfdnr',
                                headerName: "AuftragPosLfdnr"
                            },*/
                            {
                                field: 'Hinweis'
                            },
                            {
                                field: 'Kostenstelle'
                            },
                            {
                                field: 'ErscheintAm',
                                headerName: "erscheint am",
                                width: 150
                            },
                            {
                                field: 'geliefertAm',
                                headerName: "geliefert am"
                            },

                            {
                                field: 'actions',
                                type: 'actions',
                                headerName: 'Aktionen',
                                width: 100,
                                getActions: (params) => [
                                    <Tooltip title="Reklamation">
                                        <GridActionsCellItem
                                            onClick={() => {
                                                setCurrentRow(params.row);
                                                setIsModalContactOpen(true);
                                            }}
                                            icon={<EmailIcon />} label="Reklamation" />
                                    </Tooltip>,

                                    <Tooltip title="Belege herunterladen">
                                        <GridActionsCellItem
                                            onClick={() => {
                                                setCurrentRow(params.row);
                                                setIsModalDownloadOpen(true);
                                            }}
                                            icon={<CloudDownloadIcon />} label="Download" />
                                    </Tooltip>,
                                ],
                            },
                        ]}
                    />
                </div>
            </div>
        </div>
    )
}
